import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Multiselect, {
      class: "product-select",
      modelValue: _ctx.productId,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.productId) = $event)),
      valueProp: "id",
      label: "name",
      mode: "single",
      delay: 150,
      options: _ctx.getProducts,
      filterResults: false,
      resolveOnLoad: false,
      placeholder: "Søk etter vare med varenummer, strekkode eller navn",
      onSelect: _ctx.focusAmount,
      searchable: true,
      addOptionOn: ['enter', 'tab']
    }, null, 8, ["modelValue", "options", "onSelect"])
  ]))
}